var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sc-form", {
        ref: "carrierForm",
        attrs: { autocomplete: "off" },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("div", { staticClass: "mainContent" }, [
                  !_vm.isEdit
                    ? _c("div", { staticClass: "mainContent__paragraphs" }, [
                        _c("p", [
                          _vm._v(
                            "\n              Esses são os dados que a transportadora irá utilizar para atualizar as ocorrências do pedido, iremos enviar para o parceiro realizar a configuração, sinta-se a vontade para reforçar.\n            "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mainContent__data" }, [
                    _c(
                      "div",
                      { staticClass: "mainContent__token" },
                      [
                        _c("strong", [_vm._v(" TOKEN(lp-api-key): ")]),
                        _vm._v(" "),
                        _c(
                          "sc-field",
                          [
                            _c("sc-input", {
                              staticClass: "mainContent__input",
                              attrs: {
                                value: _vm.credentials.sysnode.lp_api_key,
                                id: "token",
                                readonly: "",
                                expanded: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "sc-tooltip",
                                  {
                                    attrs: {
                                      label: "Copiar",
                                      position: "is-bottom"
                                    }
                                  },
                                  [
                                    _c("sc-button", {
                                      attrs: {
                                        id: "copy-target-content",
                                        theme: "primary",
                                        icon: "copy",
                                        text: _vm.copyText,
                                        disabled: !!_vm.copyText,
                                        "data-clipboard-target": "#token"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mainContent__andress" },
                      [
                        _c("strong", [_vm._v(" Endereço do SFTP: ")]),
                        _vm._v(" "),
                        _c(
                          "sc-field",
                          [
                            _c("sc-input", {
                              staticClass: "mainContent__input",
                              attrs: {
                                value: _vm.credentials.ftp.host,
                                id: "andress",
                                readonly: "",
                                expanded: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "sc-tooltip",
                                  {
                                    attrs: {
                                      label: "Copiar",
                                      position: "is-bottom"
                                    }
                                  },
                                  [
                                    _c("sc-button", {
                                      attrs: {
                                        id: "copy-target-content",
                                        theme: "primary",
                                        icon: "copy",
                                        text: _vm.copyText,
                                        disabled: !!_vm.copyText,
                                        "data-clipboard-target": "#andress"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mainContent__user" },
                      [
                        _c("strong", [_vm._v(" Usuário do SFTP: ")]),
                        _vm._v(" "),
                        _c(
                          "sc-field",
                          [
                            _c("sc-input", {
                              staticClass: "mainContent__input",
                              attrs: {
                                value: _vm.credentials.ftp.username,
                                id: "userFtp",
                                readonly: "",
                                expanded: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "sc-tooltip",
                                  {
                                    attrs: {
                                      label: "Copiar",
                                      position: "is-bottom"
                                    }
                                  },
                                  [
                                    _c("sc-button", {
                                      attrs: {
                                        id: "copy-target-content",
                                        theme: "primary",
                                        icon: "copy",
                                        text: _vm.copyText,
                                        disabled: !!_vm.copyText,
                                        "data-clipboard-target": "#userFtp"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mainContent__password" },
                      [
                        _c("strong", [_vm._v(" Senha do SFTP: ")]),
                        _vm._v(" "),
                        _c(
                          "sc-field",
                          [
                            _c("sc-input", {
                              staticClass: "mainContent__input",
                              attrs: {
                                value: _vm.credentials.ftp.password,
                                id: "password",
                                readonly: ""
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c(
                                  "sc-tooltip",
                                  {
                                    attrs: {
                                      label: "Copiar",
                                      position: "is-bottom"
                                    }
                                  },
                                  [
                                    _c("sc-button", {
                                      attrs: {
                                        id: "copy-target-content",
                                        theme: "primary",
                                        icon: "copy",
                                        text: _vm.copyText,
                                        disabled: !!_vm.copyText,
                                        "data-clipboard-target": "#password"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mainContent__folders" }, [
                    _c("h1", [_c("strong", [_vm._v(" Pastas criadas: ")])]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("/NOTFIS")]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("/OCOREN")]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("/CTE")]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("/CONEMB")]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("/DOCCOB")])
                  ])
                ]),
                _vm._v(" "),
                _c("help-button")
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _vm.isEdit
                  ? _c(
                      "div",
                      { staticClass: "editButtons" },
                      [
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Cancelar", theme: "primary" }
                        }),
                        _vm._v(" "),
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Salvar", theme: "primary" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("sc-button", {
                          attrs: {
                            text: "Próximo",
                            theme: "primary",
                            type: "button"
                          },
                          on: { click: _vm.navigateNext }
                        })
                      ],
                      1
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1159552e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1159552e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-data-carrier/ScDataCarrier.vue
// module id = null
// module chunks = 